export default function XIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M9.4285 6.85221L15.0135 0.5H13.6905L8.839 6.0144L4.967 0.5H0.5L6.3565 8.83955L0.5 15.5H1.823L6.943 9.67535L11.033 15.5H15.5M2.3005 1.47619H4.333L13.6895 14.5718H11.6565"
        fill="#0A1B2F"
      />
    </svg>
  );
}
